import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { MemberOrderLimits, MemberPurchaseOrder, MemberPurchaseOrderDetail } from './models/member-purchase-order';
import { memberOrderParams } from '../../common/utils/member-order-params';

export class OrdersApi {
    constructor(protected baseUrl: string) {}

    public cget = (searchParams: URLSearchParams): Promise<ApiResult<PaginatedResponse<MemberPurchaseOrder>>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/purchase-orders`, { params: memberOrderParams(searchParams) }),
            response => response.data
        );

    public get = (id: number): Promise<ApiResult<MemberPurchaseOrderDetail>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/purchase-orders/${id}`),
            response => response.data
        );

    /** The member's own limits, also before there is a cart. */
    public getLimits = (): Promise<ApiResult<MemberOrderLimits>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/order-limits`),
            response => response.data
        );

    /** How many articles lie in the shop's cart; no cart answers with nothing, which is none. */
    public getCartItemCount = (): Promise<ApiResult<number>> =>
        safeRequest(
            () => request.get(`${this.baseUrl}/shopping-cart-minimal`),
            response => (response.data as { itemCount?: number } | undefined)?.itemCount ?? 0
        );

    /** Into the shop's cart: the portal and the shop share the session (#2282). */
    public addToCart = (productId: number, quantity: number): Promise<ApiResult<unknown>> =>
        safeRequest(
            () => request.post(`${this.baseUrl}/shopping-cart/items/add`, { productId, quantity }),
            response => response.data
        );
}
